const Support = ({ data }) => (
  <section id="support" className="relative tc lh-copy white">
    <Img
      sizes={data.image.childImageSharp.sizes}
      alt=""
      className="fill"
      critical={true}
      style={{ position: `absolute`, zIndex: `-1` }}
    />
    <div className="bg-black-20 pv6">
      <div className="container">
        {/* Heading */}
        <h2 className="heading mb4">{data.heading}</h2>

        {/* Pitch */}
        <p
          dangerouslySetInnerHTML={{ __html: data.paragraph }}
          className="ml-auto mr-auto mb4 pb3 abeezee"
          style={{ maxWidth: `47ch` }}
        />

        {/* Support link */}
        <div className="flex justify-center">
          <HyperLink
            href={data.link.url}
            className="group relative flex items-center"
            style={{ height: `40px` }}
          >
            <ArrowRight className="bg-purple" />
            <div className="lh-solid ttu" style={{ paddingTop: `.2rem`, paddingLeft: `4rem` }}>
              {data.link.text}
            </div>
          </HyperLink>
        </div>
      </div>
    </div>
  </section>
)

export default Support

/*
 *
 * Imports
 * 
 */

import React from 'react'

import ArrowRight from '../components/ArrowRight'
import HyperLink from '../components/base/HyperLink'
import Img from '../components/base/Img'



// WEBPACK FOOTER //
// ./src/sections/Support.js